export async function getWxConfig(data = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      xhr.onload = null;
      if (xhr.status === 200) {
        try {
          const res = JSON.parse(xhr.responseText) || {};
          const data = res.data || {};
          const sign = data.sign || {};

          const ret = {
            appId: sign.appId,
            nonceStr: sign.noncestr,
            timestamp: sign.timestamp,
            signature: sign.sign,
            debug: false,
            jsApiList: [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareWeibo",
              "onMenuShareQQ",
              "onMenuShareQZone",
            ],
          };
          console.log(ret);

          resolve(ret);
        } catch (err) {
          reject(err);
        }
      } else {
        reject(new Error("reject"));
      }
    };
    xhr.onerror = xhr.onabort = () => {
      xhr.onerror = xhr.onabort = null;
      reject(new Error("reject"));
    };
    // fix same-origin
    xhr.withCredentials = false;

    xhr.open(
      "GET",
      `https://pubwx.moseeker.com/sys/appinit?tid=3&e=5&lang=zn&token=&url=${data.url}`,
      true
    );
    xhr.send(JSON.stringify(data));
  });
}
